module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-item-section",
    class: _vm.className
  }, [(_vm.showSendMessage) ? _c('send-message', {
    attrs: {
      "receiver": _vm.user,
      "dismiss": _vm.dismissMessageModal
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_c('div', {
    staticClass: "activity-item-profile-avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')'
    })
  })]), _vm._v(" "), (false && _vm.user.id != _vm.$store.state.auth.user.id) ? _c('div', {
    staticClass: "activity-item-profile-cover"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "profile-cover"
  }, [_c('div', {
    staticClass: "profile-cover-body"
  }, [_c('div', {
    staticClass: "profile-cover-avatar"
  }, [_c('router-link', {
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_c('div', {
    staticClass: "activity-item-profile-avatar",
    style: ({
      'background-image': 'url(' + _vm.user.avatar.thumb.url + ')',
    })
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "profile-cover-content"
  }, [_c('router-link', {
    staticClass: "user-name",
    attrs: {
      "to": '/' + _vm.user.slug
    }
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" \n          "), (_vm.user.user_type == 'artist') ? _c('v-icon', {
    staticClass: "user-status",
    class: {
      online: _vm.user.status == 'active'
    }
  }, [_vm._v("fa-check-circle")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "user-followers"
  }, [_c('b', [_vm._v(_vm._s(_vm.user.followers))]), _vm._v(" Followers")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "profile-cover-action-buttons"
  }, [(_vm.user.id != _vm.$store.state.auth.user.id) ? _c('user-follow-btn', {
    attrs: {
      "user": _vm.user,
      "theme": "dark",
      "type": "default"
    },
    on: {
      "afterFollow": _vm.afterFollow
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "text-button",
    nativeOn: {
      "click": function($event) {
        _vm.showMessageDialog()
      }
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('v-menu', {
    staticClass: "more-menu",
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    staticClass: "image-button",
    attrs: {
      "slot": "activator",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    key: "repost"
  }, [_c('v-list-tile-title', {
    staticClass: "default-menu-item",
    nativeOn: {
      "click": function($event) {
        _vm.blockUser()
      }
    }
  }, [_c('label', [_vm._v("Block User")])])], 1)], 1)], 1)], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-cover-arrow"
  }, [_c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-797b916d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profileitem.vue
// module id = 1789
// module chunks = 180